export const BOARD_SIZE_CHANGE = 'BOARD_SIZE_CHANGE'



/** WEBPACK FOOTER **
 ** ./src/containers/GridBackground/modules/constants.js
 **/